var map = {
	"./Alimento/atras.png": 246,
	"./Alimento/derecha.png": 247,
	"./Alimento/fondo.jpg": 248,
	"./Alimento/frente.png": 249,
	"./Alimento/izquierda.png": 250,
	"./Alimento/izqv2.png": 251,
	"./Alimento/tituloEN.png": 252,
	"./Alimento/tituloES.png": 253,
	"./Juguetes/fondo.jpg": 254,
	"./Juguetes/titulo.png": 255,
	"./Juguetes/tituloEN.png": 256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 322;